import { render, staticRenderFns } from "./payout2.vue?vue&type=template&id=39629726"
import script from "./payout2.vue?vue&type=script&lang=js"
export * from "./payout2.vue?vue&type=script&lang=js"
import style0 from "./payout2.vue?vue&type=style&index=0&id=39629726&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports